import * as yup from "yup";
import { onlyLettersRegex } from "../lib/validationPatterns";

const isRequiredMessage = "Completa este campo";

export default yup.object().shape({
    firstname: yup.string().required(isRequiredMessage)
    .trim()
    .max(50, "Máximo 50 caracteres")
    .matches(onlyLettersRegex, "Introduzca solo letras"),
    lastname: yup.string().required(isRequiredMessage)
    .trim()
    .matches(onlyLettersRegex, "Introduzca solo letras")
    .max(60, "Máximo 60 caracteres"),
    phone: yup.string().required(isRequiredMessage)
    .trim()
    .matches(/^[0-9]+$/, "Introduzca solo números")
    .min(9, 'Introduzca exactamente 9 números')
    .max(9, 'Introduzca exactamente 9 números'),
    email: yup.string().trim().required(isRequiredMessage).email(),
    numCollegiate: yup.string().required(isRequiredMessage),
});
